import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/lib/api.service';
import { SeriesService } from 'app/lib/series.service';
import { UserService } from 'app/lib/user.service';
import { User } from 'app/models/user';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-series-dashboard',
    templateUrl: './series-dashboard.component.html',
    styleUrls: ['./series-dashboard.component.scss'],
})
export class SeriesDashboardComponent implements OnInit {
    user: User;
    categoryList = [];
    private categorySubscription: Subscription | null = null;
    seriesTypes: Array<any> = ['video', 'audio', 'daily'];
    // seriesTypes: Array<any> = ['video', 'audio'];
    enableVoiceSeries: boolean;
    enableDailySeries: boolean;
    isLoaded: boolean = false;
    constructor(
        private api: ApiService,
        private router: Router,
        private userService: UserService,
        private seriesService: SeriesService
    ) {
        this.getCategories();
        this.enableVoiceSeries =
            this.seriesService.checkSeriesTypesEnabled().enableStorySeries ||
            this.seriesService.checkSeriesTypesEnabled()
                .enableBurningQuestionSeries;
        this.enableDailySeries =
            this.seriesService.checkSeriesTypesEnabled().enableDailySeries;
    }

    ngOnInit(): void {
        this.user = this.userService.getUser();
    }
    getCategories() {
        this.seriesService.categories.subscribe(
            data => {
                this.categoryList = data;
                this.isLoaded = true;
            },
            (error: any) => {
                this.categoryList = [];
                this.isLoaded = true;
            }
        );
        this.seriesService.getCategories();
    }
    categoryDetail(resource) {
        // this.router.navigate('series')
    }
    checkSeriesEnabled(type: string) {
        switch (type) {
            case 'video':
                return true;
            case 'audio':
                return this.enableVoiceSeries;
            case 'daily':
                return this.enableDailySeries;
        }
    }
    goToSeries(type: string, category) {
        if (!this.user.isFullAccess) {
            // this.showBlocked();
        } else {
            switch (type) {
                case 'type':
                    this.router.navigate(['/app/series/' + category]);
                    break;
                case 'category':
                    this.router.navigate([
                        '/app/series/category-details/' + category,
                    ]);
                    break;
            }
        }
    }
    shouldShowCategory(category: any): boolean {
        return (
            category.Key !== 'all' &&
            (category.hasVideos > 0 ||
                category.hasStories > 0 ||
                category.hasDailySeries > 0 ||
                category.hasBurningQuestions > 0)
        );
    }
}
